const REPORT_TYPE = Object.freeze({
  VEHICLES: "VEH",
  SALES: "SAL",
  RENTALS: "REN",
  OCCUPANCY: "OCC",
});

const REPORT_URL_TYPE = Object.freeze({
  VEHICLES: "vehicles",
  SALES: "sales",
  RENTALS: "rentals",
  OCCUPANCY: "occupancy",
});

const REPORT_OCCUPANCY_TYPE = Object.freeze({
  GROUPED: "OGRO",
  BY_LOCATION: "OBRN",
  BY_BRANCH: "OBRN",
  BY_VEHICLE: "OVEH",
  BY_MODEL: "OMOD",
  BY_CATEGORY: "OCAT",
  BY_GROUP_SEATS: "OGRS",
  BY_PRICING: "OPRI",
  BY_USER: "OUSE",
  BY_COMPANY: "OCOM",
  BY_COMPANY_DRIVER: "OCDR",
});

const REPORT_SALE_TYPE = Object.freeze({
  GROUPED: "SGRO",
  BY_VEHICLE: "SVEH",
  BY_USER: "SUSE",
  BY_COMPANY: "SCOM",
  BY_PRICING: "SPRI",
  BY_LOCATION: "SLOC",
});

const REPORT_VEHICLE_TYPE = Object.freeze({
  MILEAGE: "VMIL",
  KMS_TRAVELED: "VKMS",
  EXPENSE: "VEXP",
});

const REPORT_RENTAL_TYPE = Object.freeze({
  GROUPED: "RGRO",
  BY_VEHICLE: "RVEH",
  BY_USER: "VUSE",
  BY_COMPANY: "RCOM",
  BY_PRICING: "VPRI",
  BY_LOCATION: "VLON",
  BY_GROUP_SEATS: "RGRS",
  // Front-only code for the Corporate use sub-report. NEVER sent as reportFilterType
  // (the back answers 400 incorrectFilterType); the dedicated endpoint forces RGRO.
  CORPORATE_USE: "CORPORATE_USE",
});

// Hour segments of a rate, used to filter the Corporate use export.
const REPORT_HOUR_SEGMENT = Object.freeze({
  GENERAL: "GENERAL",
  SEGMENT_1: "SEGMENT_1",
  SEGMENT_2: "SEGMENT_2",
});

const REPORT_PERIOD = Object.freeze({
  DAY: "DAY",
  HOUR: "HOUR",
  WEEK: "WEEK",
  MONTH: "MONTH",
});

const REPORT_RENTAL_TIME_TYPE = Object.freeze({
  CREATED: "CRE",
  STARTED: "STA",
  FINISHED: "FIN",
  IN_PROGRESS: "INP",
});

const REPORT_SALES_STATUS = Object.freeze({
  PAID: "PAI",
  PENDING: "PEN",
  NOT_INVOICED: "NIN",
  INVOICED: "INV",
});

const REPORT_SALES_DATES = Object.freeze({
  CREATION: "CRE",
  PAID: "PAI",
  INVOICE: "INV",
});

const REPORT_SALES_SERVICE_TYPE = Object.freeze({
  NO_SERVICE: "NSE",
  WITHOUT_RESERVE: "WRE",
  RESERVATION: "RES",
  SUBSCRIPTION: "SUB",
  OPERATION: "OPE",
});

const REPORT_OCCUPANCY_SERVICE_TYPE = Object.freeze({
  WITHOUT_RESERVE: "WRE",
  RESERVATION: "RES",
  SUBSCRIPTION: "SUB",
  OPERATION: "OPE",
});

const REPORT_OCCUPANCY_TIME_TYPE = Object.freeze({
  CURRENT_WEEK: "CWE",
  PREVIOUS_WEEK: "PWE",
  CURRENT_MONTH: "CMO",
  PREVIOUS_MONTH: "PMO",
  CURRENT_YEAR: "CYE",
  PREVIOUS_YEAR: "PYE",
  CUSTOM: "CUS",
});

const REPORT_OCCUPANCY_DAYS = Object.freeze({
  MONDAY: "MON",
  TUESDAY: "TUE",
  WEDNESDAY: "WED",
  THURSDAY: "THU",
  FRIDAY: "FRI",
  SATURDAY: "SAT",
  SUNDAY: "SUN",
});

const REPORT_RENTALS_SERVICE_TYPE = Object.freeze({
  WITHOUT_RESERVE: "WRE",
  RESERVATION: "RES",
  SUBSCRIPTION: "SUB",
});

const REPORT_VEHICLE_CONNECTIVITY_TYPE = Object.freeze({
  CONNECTED: "VCO",
  NOT_CONNECTED: "VNC",
});

export default {
  TYPE: REPORT_TYPE,
  URL_TYPE: REPORT_URL_TYPE,
  SALE_TYPE: REPORT_SALE_TYPE,
  OCCUPANCY_TYPE: REPORT_OCCUPANCY_TYPE,
  VEHICLE_TYPE: REPORT_VEHICLE_TYPE,
  RENTAL_TYPE: REPORT_RENTAL_TYPE,
  HOUR_SEGMENT: REPORT_HOUR_SEGMENT,
  PERIOD: REPORT_PERIOD,
  RENTAL_TIME_TYPE: REPORT_RENTAL_TIME_TYPE,
  SALES_STATUS: REPORT_SALES_STATUS,
  SALES_DATES: REPORT_SALES_DATES,
  SALES_SERVICE_TYPE: REPORT_SALES_SERVICE_TYPE,
  OCCUPANCY_SERVICE_TYPE: REPORT_OCCUPANCY_SERVICE_TYPE,
  OCCUPANCY_TIME_TYPE: REPORT_OCCUPANCY_TIME_TYPE,
  OCCUPANCY_DAYS: REPORT_OCCUPANCY_DAYS,
  RENTALS_SERVICE_TYPE: REPORT_RENTALS_SERVICE_TYPE,
  VEHICLE_CONNECTIVITY_TYPE: REPORT_VEHICLE_CONNECTIVITY_TYPE,
};
